export default "/images/s_rank.webp?82a7635eac233e7ba406a13668308bf1";